import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateServiceAlias, UpdateServiceAliasParams } from "../actions/updateServiceName";

export const useUpdateServiceAlias = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateServiceAliasParams) => updateServiceAlias(payload),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["scopeOfWork"],
      });

      queryClient.invalidateQueries({
        queryKey: ["job", String(variables.jobId)],
      });

      queryClient.invalidateQueries({
        queryKey: ["jobs"],
      });
    },

    retry: 0,
  });
};
